import { render } from "./IconDotsHorisontal.vue?vue&type=template&id=398b348b"
import script from "./IconDotsHorisontal.vue?vue&type=script&lang=js"
export * from "./IconDotsHorisontal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miniapp-meter-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/components/Icons/Icons/24/IconDotsHorisontal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "398b348b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('398b348b', __exports__)) {
    api.reload('398b348b', __exports__)
  }
  
  module.hot.accept("./IconDotsHorisontal.vue?vue&type=template&id=398b348b", () => {
    api.rerender('398b348b', render)
  })

}


export default __exports__